<template>
  <div class="nav-link btn-notification mx-lg-3 button__cart">
    <font-awesome-icon
      :icon="{ prefix: 'fas', iconName: 'cart-shopping' }"
      style="color: var(--green); width: 16px"
    />
    <span variant="none" class="badge-notification badge__item-amount">{{
      userCart ? userCart.count_items : ''
    }}</span>
  </div>
</template>

<script>
import Cart from '@/models/Cart';

export default {
  props: {
    userId: {
      type: Number,
      default: null
    }
  },
  computed: {
    userCart() {
      return this.userId ? Cart.query().where('user_id', this.userId).first() : null;
    }
  },
  async mounted() {
    await this.fetch();
  },
  methods: {
    async fetch() {
      if (!this.userId) return;

      const {
        response: { data }
      } = await Cart.api().fetchMyCountItems({}, false);

      Cart.insertOrUpdate({
        data: [data]
      });
    }
  }
};
</script>
